import React, { FC } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { getCalenderInstances } from "store/actions/promotion.actions";
import { PROMOTION_CALENDAR_GET_INSTANCES } from "store/store.types";
import { useApiInfo } from "hooks";
import { IState } from "store/store.interface";
import InstancesList from "./InstanceList";

const useStyles = makeStyles({
  summary: {
    flexDirection: "row-reverse",
  },
  expandIcon: {
    marginRight: 8,
  },
});

interface IProps {
  id: string;
  type?: string;
  activeAccordionId?: string | null;
  onAccordionToggle?: (id: string | null) => void;
}

const RecurrenceInstances: FC<IProps> = ({
  id,
  type,
  activeAccordionId,
  onAccordionToggle,
}) => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { instances = [] } = useSelector((state: IState) => state.promotion);
  const { isLoading } = useApiInfo(PROMOTION_CALENDAR_GET_INSTANCES);

  const isExpanded = activeAccordionId === id;

  const handleChange = (_event: React.ChangeEvent<{}>, expanded: boolean) => {
    // Fetch data when expanding
    if (expanded && id && type) {
      dispatch(getCalenderInstances(id, type.replace("_", "-").toLowerCase()));
    }
    // Update parent state to handle accordion expansion
    onAccordionToggle?.(expanded ? id : null);
  };

  return (
    <Box mt={3}>
      <Accordion expanded={isExpanded} onChange={handleChange}>
        <AccordionSummary
          expandIcon={<ArrowForwardIosIcon fontSize="small" />}
          classes={{
            root: classes.summary,
            expandIcon: classes.expandIcon,
          }}
        >
          <Box fontWeight={600}>{`Show Instances ${instances?.length && isExpanded && !isLoading ? `(Count : ${instances?.length})` : ""}`}</Box>
        </AccordionSummary>
        <AccordionDetails>
          {isLoading && isExpanded ? (
            <>
              <CircularProgress size={20} />
              <Box ml={1} fontWeight={500}>
                Loading...
              </Box>
            </>
          ) : instances?.length > 0 ? (
            <InstancesList instances={instances} />
          ) : (
            <Box color="text.secondary" fontWeight={600}>
              No Calendar Instance Available
            </Box>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default RecurrenceInstances;
